/** @format */

import React from "react";

export default function Pagination({ pagination, getPageData }) {
  const renderSpan = (style, text) => {
    return (
      <div
        className={`pagination-cont__${style}`}
        onClick={() => getPageData(text)}
      >
        {text}
      </div>
    );
  };
  return (
    <div className="pagination-cont">
      {!pagination.hasNext && pagination.current_page - 2 > 0
        ? renderSpan("notSelected ", pagination.current_page - 2)
        : null}
      {pagination.hasPrev
        ? renderSpan("notSelected ", pagination.current_page - 1)
        : null}
      {renderSpan("selected", pagination.current_page)}
      {pagination.hasNext
        ? renderSpan("notSelected ", pagination.current_page + 1)
        : null}
      {!pagination.hasPrev &&
      pagination.hasNext &&
      pagination.totalPages === pagination.current_page + 2
        ? renderSpan("notSelected ", pagination.current_page + 2)
        : null}
      {pagination.current_page + 2 >= pagination.totalPages ? null : (
        <span>....</span>
      )}
      {pagination.current_page + 2 >= pagination.totalPages
        ? null
        : renderSpan("notSelected ", pagination.totalPages)}
    </div>
  );
}
